import(/* webpackMode: "eager" */ "/app/node_modules/@mui/material/Box/index.js");
;
import(/* webpackMode: "eager" */ "/app/src/layouts/main/document-layout.jsx");
;
import(/* webpackMode: "eager" */ "/app/src/layouts/main/layout.jsx");
